import { useCallback, useEffect, useState } from 'react';
import { fetchRows, TableName } from '@/lib/api';

export function useCollection<T>(
  table: TableName,
  orderBy = 'created_at',
  ascending = false,
) {
  const [rows, setRows] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchRows<T>(table, orderBy, ascending);
      setRows(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load data');
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [table, orderBy, ascending]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { rows, loading, error, reload };
}